<script setup>
import { h, computed, defineProps } from 'vue';
import { normalizeCountryCodeForDisplay } from 'dashboard/helper/flag';

const props = defineProps({
  country: { type: String, required: true },
  squared: { type: Boolean, default: false },
});

const normalizedCountry = computed(() =>
  normalizeCountryCodeForDisplay(props.country)
);

const renderFlag = () => {
  const classes = ['fi', 'flex-shrink-0'];
  if (normalizedCountry.value) {
    classes.push(`fi-${normalizedCountry.value.toLowerCase()}`);
  }
  if (props.squared) {
    classes.push('fis');
  }
  return h('span', { class: classes });
};
</script>

<template>
  <component :is="renderFlag" />
</template>

<style>
@import 'flag-icons/css/flag-icons.min.css';
</style>
